import authRoles from '../../auth/authRoles';
import { lazy } from 'react';

const Oauth2LoginPage = lazy(() => import(`./Oauth2LoginPage`));

const Oauth2Config = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: 'oauth2-login',
      element: <Oauth2LoginPage />,
    },
  ],
};

export default Oauth2Config;
